import React, { memo, useMemo } from "react";

import { CustomInput } from "components";
import { FieldWithReadOnlyMode } from "components/formFields";
import { hasPermissions, viewSensitiveDataFullPermissionSet } from "helpers";
import {
	exactNumberOfDigitsMask9,
	exactLengthNumbers9,
	required,
	normalizeAll,
} from "validators";

type ABAFieldProps = {
	loading: boolean;
	value: string | undefined;
	isEditable: boolean;
};

function ABAField({ value, loading, isEditable }: ABAFieldProps) {
	const isFieldEditable = useMemo(
		() => isEditable && hasPermissions(viewSensitiveDataFullPermissionSet),
		[isEditable],
	);

	return (
		<FieldWithReadOnlyMode
			label="Routing Number (ABA)"
			component={CustomInput}
			smLabel={5}
			smSelect={7}
			type="text"
			validate={[required, exactLengthNumbers9]}
			normalize={normalizeAll([exactNumberOfDigitsMask9])}
			name={"aba"}
			blurLoading={loading}
			readOnlyProps={{
				isEditable: isFieldEditable,
				value,
			}}
		/>
	);
}

const component = memo(ABAField);
export { component as ABAField };
